import React from "react";
import {
  Animation,
  FORWARD,
  FORWARD_REVERSE,
} from "../AnimationRunner/AnimationRunner";
import box1Anim from "../../animations/box1";
import box2Anim from "../../animations/box2";
import effect1aAnim from "../../animations/effect1a";
import effect1bAnim from "../../animations/effect1b";
import effect2aAnim from "../../animations/effect2a";
import effect2bAnim from "../../animations/effect2b";

export default function PassionProductAnim() {
  return (
    <>
      <Animation
        animationData={box2Anim}
        className="absolute left-16 top-0 w-80 h-80 hidden lg:block upDownAnimation"
        type={FORWARD}
        lineWidth={13}
      ></Animation>
      <Animation
        animationData={effect2aAnim}
        className="absolute right-60 top-0 w-32 h-32 hidden lg:block upDownAnimation delay"
        type={FORWARD}
        lineWidth={22}
      ></Animation>
      <Animation
        animationData={box1Anim}
        className="absolute right-4 top-0 w-80 h-80 hidden lg:block upDownAnimation delay"
        type={FORWARD}
        lineWidth={13}
      ></Animation>
      <Animation
        animationData={effect1aAnim}
        className="absolute left-56 -top-12 w-40 h-40 hidden lg:block upDownAnimation delay"
        type={FORWARD}
        lineWidth={18}
      ></Animation>
      <Animation
        animationData={effect1bAnim}
        className="absolute left-0 -bottom-12 w-40 h-40 hidden lg:block upDownAnimation delay"
        type={FORWARD}
        lineWidth={18}
      ></Animation>
    </>
  );
}
